/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItemFilterItemOutputWithPermission,
    BrandAndMarketListItemFilterItemOutputWithPermissionFromJSON,
    BrandAndMarketListItemFilterItemOutputWithPermissionFromJSONTyped,
    BrandAndMarketListItemFilterItemOutputWithPermissionToJSON,
    CabinClassTypeFilterItemOutput,
    CabinClassTypeFilterItemOutputFromJSON,
    CabinClassTypeFilterItemOutputFromJSONTyped,
    CabinClassTypeFilterItemOutputToJSON,
    FareSubtypeFilterItemOutput,
    FareSubtypeFilterItemOutputFromJSON,
    FareSubtypeFilterItemOutputFromJSONTyped,
    FareSubtypeFilterItemOutputToJSON,
    FareTypeFilterItemOutput,
    FareTypeFilterItemOutputFromJSON,
    FareTypeFilterItemOutputFromJSONTyped,
    FareTypeFilterItemOutputToJSON,
    GuidFilterItemOutput,
    GuidFilterItemOutputFromJSON,
    GuidFilterItemOutputFromJSONTyped,
    GuidFilterItemOutputToJSON,
    GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutput,
    GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutputFromJSON,
    GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutputFromJSONTyped,
    GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutputToJSON,
    Int32FilterItemOutput,
    Int32FilterItemOutputFromJSON,
    Int32FilterItemOutputFromJSONTyped,
    Int32FilterItemOutputToJSON,
    JourneyTypeFilterItemOutput,
    JourneyTypeFilterItemOutputFromJSON,
    JourneyTypeFilterItemOutputFromJSONTyped,
    JourneyTypeFilterItemOutputToJSON,
    PriorityTypeFilterItemOutput,
    PriorityTypeFilterItemOutputFromJSON,
    PriorityTypeFilterItemOutputFromJSONTyped,
    PriorityTypeFilterItemOutputToJSON,
    StringFilterItemOutput,
    StringFilterItemOutputFromJSON,
    StringFilterItemOutputFromJSONTyped,
    StringFilterItemOutputToJSON,
    StringFilterItemOutputWithIndent,
    StringFilterItemOutputWithIndentFromJSON,
    StringFilterItemOutputWithIndentFromJSONTyped,
    StringFilterItemOutputWithIndentToJSON,
    WeightFilterItemOutput,
    WeightFilterItemOutputFromJSON,
    WeightFilterItemOutputFromJSONTyped,
    WeightFilterItemOutputToJSON,
} from './';

/**
 * 
 * @export
 * @interface AllFiltersOutput
 */
export interface AllFiltersOutput {
    /**
     * 
     * @type {Array<GuidFilterItemOutput>}
     * @memberof AllFiltersOutput
     */
    agencyGroups?: Array<GuidFilterItemOutput> | null;
    /**
     * 
     * @type {Array<BrandAndMarketListItemFilterItemOutputWithPermission>}
     * @memberof AllFiltersOutput
     */
    brandsAndMarkets?: Array<BrandAndMarketListItemFilterItemOutputWithPermission> | null;
    /**
     * 
     * @type {Array<CabinClassTypeFilterItemOutput>}
     * @memberof AllFiltersOutput
     */
    cabinClasses?: Array<CabinClassTypeFilterItemOutput> | null;
    /**
     * 
     * @type {Array<Int32FilterItemOutput>}
     * @memberof AllFiltersOutput
     */
    channels?: Array<Int32FilterItemOutput> | null;
    /**
     * 
     * @type {Array<FareTypeFilterItemOutput>}
     * @memberof AllFiltersOutput
     */
    fareTypes?: Array<FareTypeFilterItemOutput> | null;
    /**
     * 
     * @type {Array<JourneyTypeFilterItemOutput>}
     * @memberof AllFiltersOutput
     */
    journeyTypes?: Array<JourneyTypeFilterItemOutput> | null;
    /**
     * 
     * @type {Array<PriorityTypeFilterItemOutput>}
     * @memberof AllFiltersOutput
     */
    priorities?: Array<PriorityTypeFilterItemOutput> | null;
    /**
     * 
     * @type {Array<StringFilterItemOutputWithIndent>}
     * @memberof AllFiltersOutput
     */
    regions?: Array<StringFilterItemOutputWithIndent> | null;
    /**
     * 
     * @type {Array<GuidFilterItemOutput>}
     * @memberof AllFiltersOutput
     */
    suppliers?: Array<GuidFilterItemOutput> | null;
    /**
     * 
     * @type {Array<GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutput>}
     * @memberof AllFiltersOutput
     */
    childSuppliers?: Array<GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutput> | null;
    /**
     * 
     * @type {Array<StringFilterItemOutput>}
     * @memberof AllFiltersOutput
     */
    timeZones?: Array<StringFilterItemOutput> | null;
    /**
     * 
     * @type {Array<WeightFilterItemOutput>}
     * @memberof AllFiltersOutput
     */
    weightUnits?: Array<WeightFilterItemOutput> | null;
    /**
     * 
     * @type {Array<FareSubtypeFilterItemOutput>}
     * @memberof AllFiltersOutput
     */
    fareSubtypes?: Array<FareSubtypeFilterItemOutput> | null;
}

export function AllFiltersOutputFromJSON(json: any): AllFiltersOutput {
    return AllFiltersOutputFromJSONTyped(json, false);
}

export function AllFiltersOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllFiltersOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'agencyGroups': !exists(json, 'agencyGroups') ? undefined : (json['agencyGroups'] === null ? null : (json['agencyGroups'] as Array<any>).map(GuidFilterItemOutputFromJSON)),
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFilterItemOutputWithPermissionFromJSON)),
        'cabinClasses': !exists(json, 'cabinClasses') ? undefined : (json['cabinClasses'] === null ? null : (json['cabinClasses'] as Array<any>).map(CabinClassTypeFilterItemOutputFromJSON)),
        'channels': !exists(json, 'channels') ? undefined : (json['channels'] === null ? null : (json['channels'] as Array<any>).map(Int32FilterItemOutputFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(FareTypeFilterItemOutputFromJSON)),
        'journeyTypes': !exists(json, 'journeyTypes') ? undefined : (json['journeyTypes'] === null ? null : (json['journeyTypes'] as Array<any>).map(JourneyTypeFilterItemOutputFromJSON)),
        'priorities': !exists(json, 'priorities') ? undefined : (json['priorities'] === null ? null : (json['priorities'] as Array<any>).map(PriorityTypeFilterItemOutputFromJSON)),
        'regions': !exists(json, 'regions') ? undefined : (json['regions'] === null ? null : (json['regions'] as Array<any>).map(StringFilterItemOutputWithIndentFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidFilterItemOutputFromJSON)),
        'childSuppliers': !exists(json, 'childSuppliers') ? undefined : (json['childSuppliers'] === null ? null : (json['childSuppliers'] as Array<any>).map(GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutputFromJSON)),
        'timeZones': !exists(json, 'timeZones') ? undefined : (json['timeZones'] === null ? null : (json['timeZones'] as Array<any>).map(StringFilterItemOutputFromJSON)),
        'weightUnits': !exists(json, 'weightUnits') ? undefined : (json['weightUnits'] === null ? null : (json['weightUnits'] as Array<any>).map(WeightFilterItemOutputFromJSON)),
        'fareSubtypes': !exists(json, 'fareSubtypes') ? undefined : (json['fareSubtypes'] === null ? null : (json['fareSubtypes'] as Array<any>).map(FareSubtypeFilterItemOutputFromJSON)),
    };
}

export function AllFiltersOutputToJSON(value?: AllFiltersOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'agencyGroups': value.agencyGroups === undefined ? undefined : (value.agencyGroups === null ? null : (value.agencyGroups as Array<any>).map(GuidFilterItemOutputToJSON)),
        'brandsAndMarkets': value.brandsAndMarkets === undefined ? undefined : (value.brandsAndMarkets === null ? null : (value.brandsAndMarkets as Array<any>).map(BrandAndMarketListItemFilterItemOutputWithPermissionToJSON)),
        'cabinClasses': value.cabinClasses === undefined ? undefined : (value.cabinClasses === null ? null : (value.cabinClasses as Array<any>).map(CabinClassTypeFilterItemOutputToJSON)),
        'channels': value.channels === undefined ? undefined : (value.channels === null ? null : (value.channels as Array<any>).map(Int32FilterItemOutputToJSON)),
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(FareTypeFilterItemOutputToJSON)),
        'journeyTypes': value.journeyTypes === undefined ? undefined : (value.journeyTypes === null ? null : (value.journeyTypes as Array<any>).map(JourneyTypeFilterItemOutputToJSON)),
        'priorities': value.priorities === undefined ? undefined : (value.priorities === null ? null : (value.priorities as Array<any>).map(PriorityTypeFilterItemOutputToJSON)),
        'regions': value.regions === undefined ? undefined : (value.regions === null ? null : (value.regions as Array<any>).map(StringFilterItemOutputWithIndentToJSON)),
        'suppliers': value.suppliers === undefined ? undefined : (value.suppliers === null ? null : (value.suppliers as Array<any>).map(GuidFilterItemOutputToJSON)),
        'childSuppliers': value.childSuppliers === undefined ? undefined : (value.childSuppliers === null ? null : (value.childSuppliers as Array<any>).map(GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutputToJSON)),
        'timeZones': value.timeZones === undefined ? undefined : (value.timeZones === null ? null : (value.timeZones as Array<any>).map(StringFilterItemOutputToJSON)),
        'weightUnits': value.weightUnits === undefined ? undefined : (value.weightUnits === null ? null : (value.weightUnits as Array<any>).map(WeightFilterItemOutputToJSON)),
        'fareSubtypes': value.fareSubtypes === undefined ? undefined : (value.fareSubtypes === null ? null : (value.fareSubtypes as Array<any>).map(FareSubtypeFilterItemOutputToJSON)),
    };
}


